// Lib
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Selectors
import { getCurrentBoardId } from '../../../../reducers/currentBoardId/currentBoardIdSelector';
import { currentBoardHasPublicEditPermissionsSelector } from '../../../../utils/permissions/elementPermissionsSelector';

// Actions
import { fetchBoardEditorTimes } from './popup/editing/boardEditorPanelActions';
import { getPermissionsForCurrentBoardIfRequired } from '../../../../utils/permissions/permissionsActions';

/**
 * Fetches the current board's sharing permissions data & last edit times.
 */
export default function useFetchBoardSharingData() {
    const currentBoardId = useSelector(getCurrentBoardId);
    const currentBoardHasPublicEditPermissions = useSelector(currentBoardHasPublicEditPermissionsSelector);

    const dispatch = useDispatch();

    const dispatchGetPermissionsForBoard = () => dispatch(getPermissionsForCurrentBoardIfRequired());
    const dispatchFetchEditorTimes = (boardId: string) => dispatch(fetchBoardEditorTimes(boardId));

    useEffect(() => {
        dispatchGetPermissionsForBoard();
    }, [currentBoardId]);

    useEffect(() => {
        if (!currentBoardHasPublicEditPermissions) return;

        dispatchFetchEditorTimes(currentBoardId);
    }, [currentBoardId, currentBoardHasPublicEditPermissions]);
}
